/**
 * ISO 3166-1 alpha-2 codes where Stripe Connect can onboard connected accounts.
 * Keep in sync with backend/src/constants/stripeConnectCountries.js
 * @see https://docs.stripe.com/api/country_specs/object
 */
export const SUPPORTED_STRIPE_CONNECT_COUNTRY_CODES = [
  "AE",
  "AG",
  "AL",
  "AM",
  "AO",
  "AR",
  "AT",
  "AU",
  "AZ",
  "BA",
  "BD",
  "BE",
  "BG",
  "BH",
  "BJ",
  "BN",
  "BO",
  "BS",
  "BT",
  "BW",
  "CA",
  "CH",
  "CI",
  "CL",
  "CO",
  "CR",
  "CY",
  "CZ",
  "DE",
  "DK",
  "DO",
  "DZ",
  "EC",
  "EE",
  "EG",
  "ES",
  "ET",
  "FI",
  "FR",
  "GA",
  "GB",
  "GH",
  "GM",
  "GR",
  "GT",
  "GY",
  "HK",
  "HR",
  "HU",
  "ID",
  "IE",
  "IL",
  "IS",
  "IT",
  "JM",
  "JO",
  "JP",
  "KE",
  "KH",
  "KR",
  "KW",
  "KZ",
  "LA",
  "LC",
  "LI",
  "LK",
  "LT",
  "LU",
  "LV",
  "MA",
  "MC",
  "MD",
  "MG",
  "MK",
  "MN",
  "MO",
  "MT",
  "MU",
  "MX",
  "MY",
  "MZ",
  "NA",
  "NE",
  "NG",
  "NL",
  "NO",
  "NZ",
  "OM",
  "PA",
  "PE",
  "PH",
  "PK",
  "PL",
  "PT",
  "PY",
  "QA",
  "RO",
  "RS",
  "RW",
  "SA",
  "SE",
  "SG",
  "SI",
  "SK",
  "SM",
  "SN",
  "SV",
  "TH",
  "TN",
  "TR",
  "TT",
  "TW",
  "TZ",
  "US",
  "UY",
  "UZ",
  "VN",
  "ZA",
];

export const SUPPORTED_STRIPE_CONNECT_COUNTRY_SET = new Set(
  SUPPORTED_STRIPE_CONNECT_COUNTRY_CODES
);

export function isSupportedStripeConnectCountry(countryCode) {
  if (typeof countryCode !== "string" || !countryCode.trim()) {
    return false;
  }
  return SUPPORTED_STRIPE_CONNECT_COUNTRY_SET.has(countryCode.trim().toUpperCase());
}

export function getStripeConnectCountryCode(selectedCountry, countries = []) {
  if (!selectedCountry) return null;

  const trimmed = selectedCountry.trim();
  if (/^[A-Za-z]{2}$/.test(trimmed)) {
    return trimmed.toUpperCase();
  }

  const match = countries.find(
    (country) =>
      country.name === trimmed ||
      country.code?.toUpperCase() === trimmed.toUpperCase()
  );

  return match?.code?.toUpperCase() || null;
}
